/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProduktDto as OkEgisServiceModelsDtoProduktDto } from '../models/OK/Egis/Service/Models/DTO/produkt-dto';

@Injectable({
  providedIn: 'root',
})
export class ProduktService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getProdukter
   */
  static readonly GetProdukterPath = '/api/v1/Produkt';

  /**
   * Returns a list of produkts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProdukter()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProdukter$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoProduktDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ProduktService.GetProdukterPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoProduktDto>>;
      })
    );
  }

  /**
   * Returns a list of produkts.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProdukter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProdukter(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoProduktDto>> {

    return this.getProdukter$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoProduktDto>>) => r.body as Array<OkEgisServiceModelsDtoProduktDto>)
    );
  }

}
